<template>
  <div class="searchEngine">
    <div class="searchCount">
      検索結果:
      <span style="color: #5978d1">{{ contentList.findContentLength }}</span>件
    </div>

    <!--  유저용   -->
    <div class="user__contents">
      <h1 class="ct__kinds">ユーザー</h1>
      <div
          class="noSearchResult"
          v-if="contentList.userContentParser.length === 0"
      >
        検索結果がありません。
      </div>

      <div v-else>
        <div
            class="ct__container"
            v-for="content of contentList.userContentParser"
        >
          <router-link
              :to="{
              name: 'detail',
              params: {
                id: content.tags,
                pilot: 'ユーザー',
              },
              hash: '#' + content.summary,
            }"
              style="text-decoration: none"
          >
            <div class="ct__header">
              <div
                  class="ct__method"
                  :class="{
                  methodBoxGet: content.method === 'get',
                  methodBoxPost: content.method === 'post',
                  methodBoxPut: content.method === 'put',
                  methodBoxDelete: content.method === 'delete',
                }"
              >
                {{ content.method }} &nbsp;&nbsp;
              </div>
              <div class="ct__summary">
                {{ content.summary }}
              </div>
            </div>

            <div
                class="ct__description"
                v-html="converted(content.description)"
            />
          </router-link>
        </div>
      </div>
    </div>

    <!--  매니저용   -->
    <div class="manager__contents">
      <h1 class="ct__kinds">管理者</h1>
      <div
          class="noSearchResult"
          v-if="contentList.managerContentParser.length === 0"
      >
        検索結果がありません。
      </div>
      <div v-else>
        <div
            class="ct__container"
            v-for="content of contentList.managerContentParser"
        >
          <router-link
              :to="{
              name: 'detail',
              params: {
                id: content.tags,
                pilot: '管理者',
              },
              hash: '#' + content.summary,
            }"
              style="text-decoration: none"
          >
            <div class="ct__header">
              <div
                  class="ct__method"
                  :class="{
                  methodBoxGet: content.method === 'get',
                  methodBoxPost: content.method === 'post',
                  methodBoxPut: content.method === 'put',
                  methodBoxDelete: content.method === 'delete',
                }"
              >
                {{ content.method }} &nbsp;&nbsp;
              </div>
              <div class="ct__summary">
                {{ content.summary }}
              </div>
            </div>

            <div
                class="ct__description"
                v-html="converted(content.description)"
            />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarkdownIt from 'markdown-it';

export default {
  name: 'SearchComponent',
  props: {
    contentList: Object,
  },
  methods: {
    converted(des) {
      const md = new MarkdownIt();
      let converted = md.render(des);
      converted = converted.replaceAll('&lt;br&gt;', '<br>');
      return converted;
    },
  },
};
</script>

<style scoped lang="scss">
.searchEngine {
  font-family: 'arial', 'Meiryo', 'MS PGothic', sans-serif !important;

  .searchCount {
    text-align: center;
    font-size: 30px;
    height: 100px;
    line-height: 100px;
  }

  .noSearchResult {
    padding: 1rem;
    font-size: 20px;
  }

  .ct__container {
    border: 1px solid #bbb;
    margin-bottom: 15px;
  }

  .ct__container,
  .ct__kinds {
    border-radius: 4px;
    padding: 1rem;

    .ct__header {
      display: flex;
      font-size: 15px;
      font-weight: bold;
    }
  }

  .ct__summary {
    color: #4c4c4c;
  }

  .ct__method {
    font-weight: bold;
    font-size: 15px;
  }

  .methodBoxGet {
    color: #61affe;
  }

  .methodBoxPost {
    color: #49cc90;
  }

  .methodBoxPut {
    color: #95507c;
  }

  .methodBoxDelete {
    color: #cc3333;
  }

  .ct__description {
    font-size: 12px;
    color: gray;
  }
}
</style>
